import styled from "styled-components";
import Tag from "../Tag/Tag";

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${props =>
    typeof props.width === "string"
      ? `
    flex: 0 0 ${props.width};
    width: ${props.width};
  `
      : false};

  ${props =>
    Array.isArray(props.width)
      ? ` 
    flex: 0 0 ${props.width[0]};
    width: ${props.width[0]};
    @media(min-width: 960px) {
      flex: 0 0 ${props.width[1]};
      width: ${props.width[1]};
    }
  `
      : false};
  padding: 16px;
  border: 1px solid #d7d7dc;
  box-shadow: 0 5px 10px -5px hsla(240, 6%, 45%, 0.1);
  background: white;
`;

export default Card;



// WEBPACK FOOTER //
// ./src/UI/Card/Card.js